var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-license-admin" },
    [
      _vm.isLicensesAvailable
        ? _c(
            "error-license-lock",
            {
              attrs: {
                title: _vm.$t.__("pages.errors.ErrorLicenseAdmin.welcome"),
                subtitles: [
                  _vm.$t.__(
                    "pages.errors.ErrorLicenseAdmin.before_tools_access_attribute_licence"
                  )
                ],
                isDisplayed: !_vm.invitationRoute
              }
            },
            [
              !_vm.invitationRoute
                ? _c(
                    "div",
                    { staticClass: "error-license-admin__content" },
                    [
                      _c(
                        "div",
                        { staticClass: "error-license-admin__select" },
                        [
                          _c(
                            "CompassSelect",
                            {
                              key: _vm.licenseSelectKey,
                              attrs: {
                                value: _vm.license,
                                disabled: _vm.loading,
                                placeholder: _vm.labels.select.placeholder,
                                size: "large"
                              },
                              on: { change: _vm.updateLicense }
                            },
                            _vm._l(_vm.availableLicenses, function(
                              availableLicense
                            ) {
                              return _c("CompassDropdownSelectOption", {
                                key: availableLicense.value,
                                attrs: {
                                  disabled: availableLicense.disabled,
                                  label: availableLicense.label,
                                  value: availableLicense.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("CompassButton", {
                        staticClass: "error-license-admin__button",
                        attrs: {
                          label: _vm.labels.buttons.continue,
                          size: "large",
                          disabled: !_vm.isContinueButtonEnabled
                        },
                        on: { click: _vm.addLicenseForStaff }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "error-license-admin__no-license" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "error-license-admin__no-license-text typographies-paragraph-medium-semibold"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Vous n'avez pas besoin de licence ?"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("CompassPlainButton", {
                            staticClass: "error-license-admin__no-license-link",
                            attrs: { label: _vm.labels.buttons.link },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goLicenseAssignmentStep($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c("license-assign", {
                    attrs: { licenseChosen: _vm.license },
                    on: { back: _vm.back }
                  })
            ],
            1
          )
        : _c("error-license-admin-no-license")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }